export enum FormDisplayType {
  GRID = "grid",
  FORM = "form",
  FORM_BUILDER = "formBuilder",
}
